var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Purchase Order Allowed')},model:{value:(_vm.purchaseOrderAllowed),callback:function ($$v) {_vm.purchaseOrderAllowed=$$v},expression:"purchaseOrderAllowed"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }